import { FC, SVGProps } from 'react';

const MyChatsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#666666',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.98077 17.4189C12.0206 17.4259 14.0628 16.5696 15.5176 14.8437C17.6944 12.2614 17.7629 8.38646 15.6725 5.73397C12.9511 2.27979 7.92457 2.06356 4.9138 5.08451C2.71291 7.29207 2.23756 10.5628 3.47066 13.238C3.57335 13.4948 3.9709 14.2005 4.23774 14.6649C4.38945 14.9288 4.37389 15.2543 4.19884 15.5025C4.02302 15.7507 3.80052 16.0685 3.62704 16.3292C3.31662 16.7952 3.64648 17.4197 4.20507 17.4189L4.63814 17.4187C6.53758 17.4179 9.31893 17.4167 9.98077 17.4189Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.37085 13.5954C7.39111 12.7462 8.08369 11.7153 9.99394 11.7153C11.9145 11.7153 12.6071 12.7462 12.6274 13.5954"
        stroke={color}
        stroke-width="1.429"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.674 8.18026C11.674 9.10828 10.9217 9.86052 9.99374 9.86052C9.06574 9.86052 8.31348 9.10828 8.31348 8.18026C8.31348 7.25226 9.06574 6.5 9.99374 6.5C10.9217 6.5 11.674 7.25226 11.674 8.18026Z"
        stroke={color}
        stroke-width="1.429"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MyChatsIcon;
